import { ArrowRight, X } from 'lucide-react';
import { useState, useEffect } from 'react';
import SpotCounter from './SpotCounter';
import TrustBadges from './TrustBadges';
import SocialProof from './SocialProof';
import PremiumCTA from './PremiumCTA';
import { pushToDataLayer } from '../utils/gtm';

export default function FloatingCTA() {
  const [isVisible, setIsVisible] = useState(false);
  const [isClosed, setIsClosed] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      // Show after scrolling 500px
      if (window.scrollY > 500 && !isClosed) {
        setIsVisible(true);
      } else if (window.scrollY <= 500) {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [isClosed]);

  if (isClosed) return null;

  return (
    <>
      {/* Mobile Sticky Bottom Bar */}
      <div
        className={`fixed bottom-0 left-0 right-0 z-50 lg:hidden transition-transform duration-300 ${
          isVisible ? 'translate-y-0' : 'translate-y-full'
        }`}
      >
        <div className="bg-gradient-to-br from-green-600 to-green-700 text-white p-4 shadow-2xl border-t-4 border-orange-500">
          <div className="flex items-center justify-between gap-3 mb-2">
            <div className="flex-1">
              <p className="font-bold text-sm">7-Tage-Body-Boost</p>
              <p className="text-xs text-green-100">49 € <span className="line-through">149 €</span></p>
            </div>
            <button
              onClick={() => setIsClosed(true)}
              className="w-8 h-8 flex items-center justify-center hover:bg-green-700 rounded-lg transition-colors flex-shrink-0"
            >
              <X className="w-5 h-5" />
            </button>
          </div>
          <div className="mb-3">
            <SpotCounter variant="compact" showProgressBar={true} />
          </div>
          <PremiumCTA
            href="https://www.digistore24.com/product/642539/siebentage5kilo/?ds24_domain=www.digistore24.com&voucher=7TageStart"
            size="sm"
            fullWidth
            onClick={() => pushToDataLayer('initiate_checkout')}
          >
            Jetzt starten
          </PremiumCTA>
        </div>
      </div>

      {/* Desktop Floating Button */}
      <div
        className={`hidden xl:block fixed bottom-8 right-8 z-50 transition-all duration-300 ${
          isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4 pointer-events-none'
        }`}
      >
        <div className="relative">
          <button
            onClick={() => setIsClosed(true)}
            className="absolute -top-2 -right-2 w-8 h-8 bg-gray-800 hover:bg-gray-900 text-white rounded-full flex items-center justify-center shadow-lg transition-colors z-10"
          >
            <X className="w-4 h-4" />
          </button>

          <div className="bg-white rounded-2xl shadow-2xl p-6 max-w-sm border-2 border-orange-500">
            <div className="space-y-4">
              <div>
                <h3 className="font-bold text-gray-900 text-lg mb-1">
                  Bereit für deine Transformation?
                </h3>
              </div>

              <SpotCounter variant="default" showProgressBar={true} />

              <div className="bg-gradient-to-br from-green-50 to-emerald-50 rounded-xl p-4 border-2 border-green-200">
                <div className="flex items-baseline gap-2 mb-1">
                  <span className="text-3xl font-bold text-green-700">49 €</span>
                  <span className="text-xl text-gray-600 line-through">149 €</span>
                </div>
                <p className="text-sm text-green-700 font-medium">
                  Bei 5 kg Verlust: 0 €
                </p>
              </div>

              <SocialProof variant="signups" showAnimation={true} />

              <PremiumCTA
                href="https://www.digistore24.com/product/642539/siebentage5kilo/?ds24_domain=www.digistore24.com&voucher=7TageStart"
                fullWidth
                onClick={() => pushToDataLayer('initiate_checkout')}
              >
                Aktionspreis sichern
              </PremiumCTA>

              <TrustBadges variant="compact" showLabels={false} />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
